import { useMemo } from "react";

export function DollarIcon({ className }: { className?: string }) {
  // Generate unique gradient ID for this instance
  const gradientId = useMemo(() => `dollar-gradient-${Math.random().toString(36).slice(2, 11)}`, []);
   
  return (
    <svg 
      className={className} 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.75 7.375C12.75 6.96079 12.4142 6.625 12 6.625C11.5858 6.625 11.25 6.96079 11.25 7.375V7.845C10.248 8.07236 9.5 8.96845 9.5 10.0392V10.3043C9.5 11.2422 10.0818 12.0817 10.9599 12.411L12.5134 12.9936C12.8061 13.1034 13 13.3832 13 13.6959V13.9609C13 14.3752 12.6642 14.7109 12.25 14.7109H11.5626C11.2519 14.7109 11 14.4591 11 14.1483C11 13.7341 10.6642 13.3983 10.25 13.3983C9.8358 13.3983 9.5 13.7341 9.5 14.1483C9.5 15.1812 10.2592 16.0368 11.25 16.1874V16.625C11.25 17.0392 11.5858 17.375 12 17.375C12.4142 17.375 12.75 17.0392 12.75 16.625V16.1552C13.752 15.9278 14.5 15.0317 14.5 13.9609V13.6959C14.5 12.758 13.9182 11.9185 13.0401 11.5891L11.4866 11.0066C11.1939 10.8968 11 10.6169 11 10.3043V10.0392C11 9.62503 11.3358 9.28924 11.75 9.28924H12.4374C12.7481 9.28924 13 9.54113 13 9.85184C13 10.2661 13.3358 10.6018 13.75 10.6018C14.1642 10.6018 14.5 10.2661 14.5 9.85184C14.5 8.81897 13.7408 7.96341 12.75 7.81278V7.375Z" 
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient 
          id={gradientId}
          x1="12" 
          y1="2" 
          x2="12" 
          y2="22" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC6256"/>
          <stop offset="1" stopColor="#E03D4F"/>
        </linearGradient>
      </defs>
    </svg>
  )
}